import { render, staticRenderFns } from "./AdminSponsors.vue?vue&type=template&id=4c13c13f"
import script from "./AdminSponsors.vue?vue&type=script&lang=js"
export * from "./AdminSponsors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports